import { UnitNotesPage } from '@apps-common/apps/portal/pages/units/pages/manage/pages/notes/Index'

export const UnitNotes = () => <UnitNotesPage />
